import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '../../../img/powershield-logo-lg-white.png';
import _imports_1 from '../../../img/powershield-logo-square-white.png';
const _hoisted_1 = {
    key: 0,
    class: "clearfix left_col scroll-view"
};
const _hoisted_2 = { class: "navbar nav_title" };
const _hoisted_3 = {
    key: 0,
    class: "production-version"
};
const _hoisted_4 = {
    id: "sidebar-menu",
    class: "main_menu main-menu-side no-print"
};
const _hoisted_5 = { class: "menu_section clearfix" };
const _hoisted_6 = { class: "nav side-menu top0" };
const _hoisted_7 = ["title"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["title"];
const _hoisted_10 = {
    key: 1,
    class: "sidebar-footer hidden-sm"
};
const _hoisted_11 = { class: "clearfix sidebar-footer-version" };
const _hoisted_12 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_13 = { class: "text-white hidden-small" };
const _hoisted_14 = { class: "hidden-small" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_SidebarStatusBar = _resolveComponent("SidebarStatusBar");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, {
                        to: { name: 'home' },
                        onClick: _ctx.goHome
                    }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("img", {
                                    class: "large-logo",
                                    src: _imports_0,
                                    width: "187"
                                }, null, -1 /* CACHED */),
                                _createTextVNode(),
                                _createElementVNode("img", {
                                    class: "small-logo",
                                    src: _imports_1,
                                    width: "48"
                                }, null, -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (_ctx.hasProductionVersion)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.appVersion), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createVNode(_component_SidebarStatusBar),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */)),
                _cache[10] || (_cache[10] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("ul", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLinks, (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    class: _normalizeClass({ 'current-page': _ctx.isCurrentPage(item), 'active': item.hasChildren && _ctx.menu == item.routeGroup, 'license-disabled': _ctx.isLicenseDisabled(item) }),
                                    title: _ctx.licenseDisabledReason(item) || undefined
                                }, [
                                    (!item.hasChildren && !_ctx.isLicenseDisabled(item))
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            tag: "a",
                                            to: { name: item.route },
                                            onClick: ($event) => (_ctx.toggleLink(item))
                                        }, {
                                            default: _withCtx(() => [
                                                (item.icon)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 0,
                                                        class: _normalizeClass(['fa', 'fa-fw', item.icon])
                                                    }, null, 2 /* CLASS */))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(" " + _toDisplayString(item.text), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "onClick"]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    (!item.hasChildren && _ctx.isLicenseDisabled(item))
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            class: "disabled-link",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["prevent"]))
                                        }, [
                                            (item.icon)
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass(['fa', 'fa-fw', item.icon])
                                                }, null, 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(" " + _toDisplayString(item.text), 1 /* TEXT */)
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    (item.hasChildren)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 2,
                                            onClick: ($event) => (_ctx.toggleMenu(item))
                                        }, [
                                            (item.icon)
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass(['fa', 'fa-fw', item.icon])
                                                }, null, 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(" " + _toDisplayString(item.text) + " ", 1 /* TEXT */),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(['fa', 'fa-fw', _ctx.isMenuOpen ? 'fa-chevron-up' : 'fa-chevron-down'])
                                            }, null, 2 /* CLASS */)
                                        ], 8 /* PROPS */, _hoisted_8))
                                        : _createCommentVNode("v-if", true),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    (item.hasChildren && _ctx.menu == item.routeGroup)
                                        ? (_openBlock(), _createElementBlock("ul", {
                                            key: 3,
                                            class: "nav child_menu child-menu-vue",
                                            style: _normalizeStyle({ display: _ctx.isMenuOpen ? 'block' : 'none' })
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleChildren(item.children), (child) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    class: _normalizeClass({ 'current-page': _ctx.route == child.route, 'license-disabled': _ctx.isLicenseDisabled(child) }),
                                                    title: _ctx.licenseDisabledReason(child) || undefined
                                                }, [
                                                    (!_ctx.isLicenseDisabled(child))
                                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                                            key: 0,
                                                            tag: "a",
                                                            to: { name: child.route },
                                                            onClick: ($event) => (_ctx.toggleLink(child))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(child.text), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "onClick"]))
                                                        : (_openBlock(), _createElementBlock("a", {
                                                            key: 1,
                                                            class: "disabled-link",
                                                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["prevent"]))
                                                        }, _toDisplayString(child.text), 1 /* TEXT */))
                                                ], 10 /* CLASS, PROPS */, _hoisted_9));
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                        ], 4 /* STYLE */))
                                        : _createCommentVNode("v-if", true)
                                ], 10 /* CLASS, PROPS */, _hoisted_7));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _cache[12] || (_cache[12] = _createTextVNode()),
        (!_ctx.hasProductionVersion)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    (_ctx.appReleaseDesignation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.appReleaseDesignation), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.appVersion), 1 /* TEXT */)
                ])
            ]))
            : _createCommentVNode("v-if", true)
    ], 64 /* STABLE_FRAGMENT */));
}
